import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getHealthScreeningServiceByClinic } from "../../../store/slices/serviceSlice";
import {
  createHealthScreeningPackage,
  updateHealthScreeningPackage,
  deleteHealthScreeningPackage,
  getHealthScreeningPackage,
  getHealthScreeningPackageById,
  resetCreateHealthScreeningMessage,
  resetUpdateHealthScreeningMessage,
  resetDeleteHealthScreeningMessage,
} from "../../../store/slices/healthScreening.slice";
import { Modal } from "react-bootstrap";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import classNames from "classnames";
import AddUpdatePackageMaster from "./AddUpdateHealthScreening";
import styles from "./package.module.scss";
import { RiProfileLine } from "react-icons/ri";
import { FaChevronRight } from "react-icons/fa6";
import { TbTestPipe } from "react-icons/tb";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import { FaTrashCan } from "react-icons/fa6";
import { getClinicTestMasterByClinicId } from "../../../store/slices/clinicTestMaster";
import ViewAllTest from "./viewAllTest";
import { getCategorySlice } from "../../../store/slices/categorySlice";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import Pagination from "../../common/pagination/pagination";

const HealthScreening = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [viewAllclinicPackage, setViewAllclinicPackage] = useState(false);
  const [selectedAction, setSelectedAction] = useState("Create");
  const { userinfo } = useSelector((state) => state.auth);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { healthScreeningServices } = useSelector((state) => state.service);
  const [statusFilter, setStatusFilter] = useState("active_inactive");
  const clinicId =clinicInfo?.[0]?.clinicId;
  const clinicObjId = clinicInfo?.[0]?._id;
  const initialState = {
    id: "",
    packageName: "",
    serviceDetails: null,
    clinicId: "",
    clinicName: "",
    clientPrice: "",
    pt_price: "",
    offerPrice: "",
    tax: "",
    insuranceCompanyName: "",
    status: "Active",
  };
  const [inputError, setInputError] = useState({
    text: false,
    onlyNumber: false,
  });
  const [clinicPackageFormData, setClinicPackageFormData] =
    useState(initialState);
  const dispatch = useDispatch();
  const { clinicTestMasterByClinicId } = useSelector(
    (state) => state.clinicTestMaster,
  );
  const { token } = useSelector((state) => state.auth);
  const {
    healthScreeningPackages,
    healthScreeningPackagesById,
    createHealthScreeningSuccessMessage,
    createHealthScreeningErrorMessage,
    updateHealthScreeningSuccessMessage,
    updateHealthScreeningErrorMessage,
    deleteHealthScreeningSuccessMessage,
    deleteHealthScreeningErrorMessage,
    totalCount,
    totalPages,
    hasMore
  } = useSelector((state) => state.healthScreening);
  const showMessageAndReset = ShowTostifyMessageAndReset();
  const [searchValue, setSearchValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 6;

  useEffect(() => {
    dispatch(getHealthScreeningPackage({ token, page: currentPage, limit: pageSize }));
    dispatch(getCategorySlice({ token }));
    dispatch(
      getHealthScreeningServiceByClinic({
        clinicId,
        token,
      }),
    );
    dispatch(
      getClinicTestMasterByClinicId({
        clinicId,
        token,
      }),
    );
  }, [dispatch, viewAllclinicPackage, userinfo, clinicInfo, token, currentPage]);

  useEffect(() => {
    showMessageAndReset(
      createHealthScreeningSuccessMessage,
      showToastifySuccess,
      resetCreateHealthScreeningMessage,
    );
    showMessageAndReset(
      createHealthScreeningErrorMessage,
      showToastifyError,
      resetCreateHealthScreeningMessage,
    );
    showMessageAndReset(
      updateHealthScreeningSuccessMessage,
      showToastifySuccess,
      resetUpdateHealthScreeningMessage,
    );
    showMessageAndReset(
      updateHealthScreeningErrorMessage,
      showToastifyError,
      resetUpdateHealthScreeningMessage,
    );
    showMessageAndReset(
      deleteHealthScreeningSuccessMessage,
      showToastifySuccess,
      resetDeleteHealthScreeningMessage,
    );
    showMessageAndReset(
      deleteHealthScreeningErrorMessage,
      showToastifyError,
      resetDeleteHealthScreeningMessage,
    );
  }, [
    createHealthScreeningSuccessMessage,
    createHealthScreeningErrorMessage,
    updateHealthScreeningSuccessMessage,
    updateHealthScreeningErrorMessage,
    dispatch,
    deleteHealthScreeningSuccessMessage,
    deleteHealthScreeningErrorMessage,
    showMessageAndReset,
  ]);

  const handlesetClinicPackageFormData = (e, names) => {
    if (names === "pathologyService") {
      const serviceDetailsValues = e?.map((service) => ({
        id: service?.value,
        type: service?.type,
      }));
      setClinicPackageFormData({
        ...clinicPackageFormData,
        serviceDetails: serviceDetailsValues,
      });
    } else {
      setClinicPackageFormData({
        ...clinicPackageFormData,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleAddOrUpdatePackage = async (e) => {
    e.preventDefault();
    const { text, onlyNumber } = inputError;
    if (text || onlyNumber) return;
    try {
      if (selectedAction === "Create") {
        await dispatch(
          createHealthScreeningPackage({
            ...clinicPackageFormData,
            createdBy: clinicObjId,
            clinicId,
            token,
          }),
        );
      } else {
        await dispatch(
          updateHealthScreeningPackage({
            ...clinicPackageFormData,
            updatedBy: clinicObjId,
            clinicId,
            token,
          }),
        );
      }
      if (statusFilter === "deleted") {
        await dispatch(
          getHealthScreeningPackage({
            token,
            status: ["Deleted"],
            clinicId,
          }),
        );
      } else {
        await dispatch(
          getHealthScreeningPackage({
            token,
            status: ["Active", "Inactive"],
            clinicId,
          }),
        );
      }
      setModalVisible(false);
      setClinicPackageFormData(initialState);
    } catch (err) {
      console.error(err);
    }
  };

  const handleEditClinicLabProfile = (data) => {
    setModalVisible(true);
    setSelectedAction("Update");
    const combinedServiceDetails = [
      ...(data?.tests?.map((test) => ({
        id: test?._id || test?.id || null,
        type: "test",
      })) || []),
      ...(data?.profiles?.map((profile) => ({
        id: profile?._id || profile?.id || null,
        type: "profile",
      })) || []),
      ...(data?.radiology?.flatMap((radiology) =>
        radiology?.rediologyServiceDetails?.map((radiologyDetails) => ({
          id: radiologyDetails?._id || radiologyDetails?.id || "",
          type: "radiology",
        })),
      ) || []),
    ];
    setClinicPackageFormData({
      id: data?._id,
      packageName: data?.packageName,
      serviceDetails: combinedServiceDetails,
      clinicId: data?.clinicId?._id,
      clinicName: data?.clinicId?.clinicName,
      clientPrice: data?.clientPrice,
      pt_price: data?.pt_price,
      offerPrice: data?.offerPrice,
      tax: data?.tax,
      insuranceCompanyName: data?.insuranceCompanyName,
      status: "Active",
    });
  };

  const handleDeleteClick = (data) => {
    setDeleteModal(true);
    setClinicPackageFormData((prevFormData) => ({
      ...prevFormData,
      id: data?._id,
      packageName: data?.packageName,
    }));
  };

  const handleConfirmDelete = async (e) => {
    e.preventDefault();
    try {
      await dispatch(
        deleteHealthScreeningPackage({
          id: clinicPackageFormData.id,
          token,
        }),
      );
      dispatch(getHealthScreeningPackage({ token, status: "Deleted" }));

      setDeleteModal(false);
    } catch (err) {
      console.error(err);
    }
  };

  const handleModal = () => {
    setSelectedAction("Create");
    setModalVisible(true);
    setClinicPackageFormData(initialState);
  };

  const heading = () => (
    <div className="form-head d-flex mb-3 mb-md-4 align-items-start w-100">
      <div className="me-4 d-none d-lg-block">
        <div
          className="btn btn-primary btn-rounded me-4"
          onClick={() => handleModal()}
        >
          + Add Package
        </div>
      </div>

      {/* Status Toggle Tabs */}
      <div className="d-flex align-items-center ms-auto me-3">
        <button
          className={`btn btn-sm me-2 ${
            statusFilter === "active_inactive"
              ? "btn-primary"
              : "btn-outline-primary"
          }`}
          onClick={() => {
            setStatusFilter("active_inactive");
            setCurrentPage(1);
            dispatch(getHealthScreeningPackage({ token, page: 1, limit: pageSize }));
          }}
        >
          Active & Inactive
        </button>
        <button
          className={`btn btn-sm ${
            statusFilter === "deleted" ? "btn-danger" : "btn-outline-danger"
          }`}
          onClick={() => {
            setStatusFilter("deleted");
            setCurrentPage(1);
            dispatch(getHealthScreeningPackage({ token, page: 1, limit: pageSize, status: "Deleted" }));
          }}
        >
          Deleted
        </button>
      </div>

      {/* Search */}
      <div className="input-group search-area d-inline-flex">
        <input
          type="text"
          className="form-control"
          placeholder="Search here"
          value={searchValue}
          onChange={handleSearch}
        />
        <div className="input-group-append d-flex">
          <button type="button" className="input-group-text">
            <FaSearch className="flaticon-381-search-2" />
          </button>
        </div>
      </div>
    </div>
  );

  const clinicPackageMasterList = () => (
    <div className="row">
      {healthScreeningPackages &&
        healthScreeningPackages?.map((item, index) => {
          const testProfileList = [
            ...(item?.tests?.map((test) => test?.testName) || []),
            ...(item?.profiles?.map((profile) => profile?.profileName) || []),
            ...(healthScreeningPackagesById?.radiology?.flatMap(
              (radiologydetailsname) =>
                radiologydetailsname.rediologyServiceDetails?.map(
                  (detail) => detail.name,
                ) || [],
            ) || []),
          ];
          return (
            <div
              className="col-xl-3 col-xxl-4 col-lg-6 col-md-6 col-sm-6"
              key={index}
            >
              <div className="card project-boxed">
                <div
                  className={classNames(
                    styles.titel,
                    "card-header",
                    "align-items-start",
                  )}
                >
                  <div className={styles.titelWrapper}>
                    <RiProfileLine />
                    <h6 className="fs-18 font-w500">
                      <Link to={"#"} className="text-black user-name">
                        {item?.packageName}
                      </Link>
                    </h6>
                  </div>
                  <Dropdown className="">
                    <Dropdown.Toggle
                      variant=""
                      as="div"
                      className="btn-link i-false"
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                          stroke="#342E59"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                          stroke="#342E59"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                          stroke="#342E59"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </Dropdown.Toggle>

                    <Dropdown.Menu align="end">
                      <Dropdown.Item
                        onClick={() => handleEditClinicLabProfile(item)}
                      >
                        Edit
                      </Dropdown.Item>

                      {statusFilter === "deleted" && (
                        <Dropdown.Item
                          className="text-danger"
                          onClick={() => handleDeleteClick(item)}
                        >
                          Permanent Delete
                        </Dropdown.Item>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                <div className="card-body p-0 pb-3">
                  <ul className="list-group list-group-flush">
                    <li className={classNames(styles.list, "list-group-item")}>
                      <span className="mb-0 title">Insurance Company Name</span>{" "}
                      :
                      <span className="text-black ms-2">
                        {item?.insuranceCompanyName}
                      </span>
                    </li>
                    <li className={classNames(styles.list, "list-group-item")}>
                      <span className="mb-0 title">Client Price</span> :
                      <span className="text-black ms-2">
                        {item?.clientPrice}
                      </span>
                    </li>
                    <li className={classNames(styles.list, "list-group-item")}>
                      <span className="mb-0 title">Patient Price</span> :
                      <span className="text-black ms-2">{item?.pt_price}</span>
                    </li>
                    <li className={classNames(styles.list, "list-group-item")}>
                      <span className="mb-0 title">Offer Price</span> :
                      <span className="text-black ms-2">
                        {item?.offerPrice}
                      </span>
                    </li>
                    <li className={classNames(styles.list, "list-group-item")}>
                      <span className="mb-0 title">Discount</span> :
                      <span className="text-black ms-2">
                        {item?.discount} %
                      </span>
                    </li>
                    <li className={classNames(styles.list, "list-group-item")}>
                      <span className="mb-0 title">Status</span> :
                      <span className="text-black ms-2">{item?.status}</span>
                    </li>
                    <b className={styles.clinicName}>Test Names:</b>
                    {testProfileList && testProfileList.length > 0 ? (
                      <>
                        {testProfileList.slice(0, 2).map((test, index) => (
                          <li
                            className={classNames(
                              styles.list,
                              "list-group-item",
                            )}
                            key={index}
                          >
                            <TbTestPipe className="ms-2" />
                            <span className="text-black ms-2">{test}</span>
                          </li>
                        ))}
                        {testProfileList.length > 2 && (
                          <li
                            className={classNames(
                              styles.list,
                              "list-group-item",
                            )}
                          >
                            <b className="mb-0 title">
                              +{testProfileList.length - 2} More Tests
                            </b>
                          </li>
                        )}
                      </>
                    ) : (
                      <li
                        className={classNames(styles.list, "list-group-item")}
                      >
                        <span className="text-muted">No tests selected</span>
                      </li>
                    )}

                    <div
                      className={styles.viewMoreWrapper}
                      onClick={() => handleViewAllclinicTestProfile(item?._id)}
                    >
                      <p>
                        View All Tests <FaChevronRight />
                      </p>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );

  const handleViewAllclinicTestProfile = (value) => {
    dispatch(getHealthScreeningPackageById({ id: value, token }));
    setViewAllclinicPackage(true);
  };

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    setCurrentPage(1); 
    const payload = {
      searchQuery: e.target.value,
      token,
      page: 1,
      limit: pageSize
    };

    if (statusFilter === "deleted") {
      payload.status = "Deleted";
    }

    dispatch(getHealthScreeningPackage(payload));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    dispatch(getHealthScreeningPackage({ 
      token, 
      page, 
      limit: pageSize,
      searchQuery: searchValue,
      status: statusFilter === "deleted" ? "Deleted" : ["Active", "Inactive"]
    }));
  };

  return (
    <>
      {heading()}
      {healthScreeningPackages?.length > 0 ? (
        clinicPackageMasterList()
      ) : (
        <h5 className="text-center mt-5">{"No Data Found"}</h5>
      )}
      
      {/* Pagination */}
      {totalCount > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalCount={totalCount}
          limit={pageSize}
          onPageChange={handlePageChange}
        />
      )}
      
      <ViewAllTest
        setViewAllclinicPackage={setViewAllclinicPackage}
        viewAllclinicPackage={viewAllclinicPackage}
        healthScreeningPackagesById={healthScreeningPackagesById}
      />
      {/* Add and Update Country Modal */}
      <AddUpdatePackageMaster
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        clinicPackageFormData={clinicPackageFormData}
        handleAddOrUpdatePackage={handleAddOrUpdatePackage}
        selectedAction={selectedAction}
        handlesetClinicPackageFormData={handlesetClinicPackageFormData}
        clinicTestMasterByClinicId={clinicTestMasterByClinicId}
        healthScreeningServices={healthScreeningServices}
        setInputTextError={setInputError}
      />
      {/* delete Modal */}
      <Modal
        centered
        show={deleteModal}
        onHide={() => setDeleteModal(false)}
        size={"md"}
      >
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            Confirm Delete
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setDeleteModal(false)}
          ></button>
        </div>
        <div className="modal-body">
          <p>
            Are you sure you want to delete the Package{" "}
            <strong className="text-dark">
              {clinicPackageFormData?.packageName}
            </strong>
            ?
          </p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setDeleteModal(false)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleConfirmDelete}
          >
            Delete
          </button>
        </div>
      </Modal>
    </>
  );
};

export default HealthScreening;
